import SockJS from 'sockjs-client';
import Stomp from 'webstomp-client';
import store from '@/store';

let socket = null;
let stompClient = null;
let isConnected = false;
let prefixUrl = '';

const disconnect = () => {
   if (podeDesconectarWebsocket()) {
       forcedDisconnect();
   }
};

const connect = async () => {
    if (isConnected) {
        return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
        socket = new SockJS(
            window.location.origin + process.env.VUE_APP_HTTP_PATH + '/ws',
            [],
            {}
        );
       let options = {debug: true, heartbeat: { incoming: 10000, outgoing: 10000}, protocols: ['v12.stomp'], binary: false};
        stompClient = Stomp.over(socket, options);
        if (process.env.NODE_ENV !== 'development') {
            stompClient.debug = () => {};
        }

        stompClient.connect(
            {
                Cookie: document.cookie
            },
            () => {
                prefixUrl = `/user/`;
                isConnected = true;
                resolve();
            },
            err => {
                disconnect();
                reject(err);
            }
        );
    });
};

const subscribe = (subscription, callback) => {
    if (!isConnected) {
        return;
    }

    waitForSocketConnection(stompClient.ws, function () {
        return stompClient.subscribe(prefixUrl + subscription, response => {
            if (typeof callback !== 'function') {
                return;
            }

            callback(response.body);
        });
    });
};

function waitForSocketConnection(socket, callback) {
    setTimeout(function () {
        if (socket.readyState === 1) {
            if (callback != null) {
                callback();
            }
        } else {
            waitForSocketConnection(socket, callback);
        }
    }, 5);
}

function podeDesconectarWebsocket() {
    return !store.state.emProcessamentoDownloadMonitoramentoAgricola && !store.state.emProcessamentoDownloadMonitoramentoSocioAmbiental &&
        !store.state.emProcessamentoDownloadLoteRenovabio && !store.state.emProcessamentoUploadLoteRenovabio;
}

function forcedDisconnect () {
    if (stompClient) {
        stompClient.disconnect();
    }
    socket = null;
    stompClient = null;
    prefixUrl = '';
    isConnected = false;
}

/**
 * Se inscreve no tópico de notificações de relatórios
 * Emite evento 'report-notification' quando recebe mensagens
 * @param {string} userId - ID do usuário (idKeyCloack)
 * @returns {Object} Subscrição que pode ser cancelada
 */
const subscribeReports = (userId) => {
    if (!isConnected) {
        return null;
    }

    const topic = `${userId}/queue/reports`;

    return subscribe(topic, response => {
        try {
            const notification = JSON.parse(response);

            // Emitir evento para componente ouvir (compatível com WebSocketService)
            window.dispatchEvent(
                new CustomEvent('report-notification', { detail: notification })
            );
        } catch (error) {
            // Erro ao processar notificação - log suprimido
        }
    });
};

export { connect, disconnect, forcedDisconnect, subscribe, subscribeReports };
